import axios from 'axios'
import api from "@/helpers/api";
import {convertSecondsToTime} from '@/helpers/formatted.js';
import router from "@/router";
import store from "@/store";
import App from "@/App";
const state = {
    items: [],
    date: false,
    dateFormat: '',
    isLoad: true,
}

// getters
const getters = {
}

const actions = {
    getItems(context, data) {
        return new Promise((resolve, reject) => {
            let date;
            if(state.date){
                date = new Date(state.date);
                date.setDate(date.getDate() - 1)
            } else {
                date = new Date();
            }
            let dateParam = date.toLocaleDateString('ru-RU');
            context.commit('setDate', date.getTime());
            context.commit('setDateFormat', dateParam);
            context.commit('setIsLoad', true);

            axios.get(process.env.VUE_APP_API_PATH+'/log/',api.axiosConfig({
                date: dateParam
            })).then(response => {
                if(typeof response.data === 'object' && +response.data.error > 0) {
                    api.errorHandler(response.data.error);
                }
                context.commit('setItems', response.data.result);
                context.commit('setIsLoad', false);
                resolve(response.data.result);
            }).catch(function (error) {
                resolve();
            });
        });
    },
}

const mutations = {
    setItems(state, data) {
        if(typeof data === 'object' && data.items !== undefined) {
            state.items = data.items;
        }
    },
    clear(state, data){
        state.items = [];
        state.date = false;
        state.dateFormat = '';
    },
    setDate(state, data){
        state.date = data;
    },
    setDateFormat(state, data){
        state.dateFormat = data;
    },
    setIsLoad(state, data){
        state.isLoad = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
